@if (
  {
    row: columnData | async,
  };
  as $
) {
  @if ($.row && ($.row.subfreeze_status || $.row.status)) {
    <div class="flex align-items-center">
      <span
        [ngClass]="renderClass($.row.subfreeze_status || $.row.status)"
        class="border-circle mr-2 p-1"
      ></span>
      <span>{{
        'FREEZE.STATUS.' +
          getFreezeStatus($.row.subfreeze_status || $.row.status) | translate
      }}</span>
    </div>
  }
}
